import type { FC, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import defaultAuthLogo from "../assets/firestarter-vertical-white.svg";
import { useBranding } from "../hooks/use-app-metadata";

export const AuthLayout = () => {
	const branding = useBranding();

	return (
		<div className="layout-auth">
			<div className="layout-auth-gradient">
				<h1>
					{branding.tagline ?? '"We Love marketing so you don\'t have to."'}
				</h1>
				<img
					src={branding.authLogoUrl ?? defaultAuthLogo}
					alt={branding.appName}
				/>
			</div>
			<div className="layout-auth-wrapper">
				<Outlet />
			</div>
		</div>
	);
};

interface AuthPageProps extends PropsWithChildren {
	title: string;
}

export const AuthPage: FC<AuthPageProps> = (props) => {
	return (
		<>
			<title>{props.title}</title>
			<div className="layout-auth-content">{props.children}</div>
		</>
	);
};
